import React from 'react'

const SubscriptionDetailsPage = () => {
  return (
    <div>SubscriptionDetailsPage</div>
  )
}

export default SubscriptionDetailsPage